export function DashboardPage () {
  return (
    <div className="max-w-4xl">
      <h1 className="text-3xl font-bold text-white mb-6">Dashboard</h1>
      <div className="card-sm">
        <p className="text-gray-300">
          Welcome to Pantheon! Use the sidebar to navigate to your prompts or view executions.
        </p>
      </div>
    </div>
  )
}
